<form *ngIf="showNamedSchedules" [formGroup]="form">
  <div class="schedule-name-header">
    <span
      class="header-schedule-name"
      *ngIf="!isScheduleNameEditMode"
      data-test="header-schedule-name"
      (dblclick)="handleDoubleClick()"
      >{{ schedule.name || 'Untitled schedule' }}</span
    >
    <input
      #scheduleName
      type="text"
      class="title-schedule-name"
      [ngClass]="{ 'input-error': form.get('name')?.invalid && form.get('name')?.touched }"
      *ngIf="isScheduleNameEditMode"
      name="name"
      autocomplete="off"
      formControlName="name"
      placeholder="Untitled schedule"
      data-test="named-schedule-input"
      (blur)="focusOutFunction()"
    />
    <capra-icon-button
      capraTooltip
      class="edit-name-button"
      tooltipContent="Double click to edit schedule name"
      tooltipPlacement="right"
      tooltipSize="mini"
      *ngIf="!isScheduleNameEditMode"
      icon="icon-pencil"
      (clicked)="editScheduleName()"
    ></capra-icon-button>
  </div>
  <span
    *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
    class="schedule-name-error"
    data-test="schedule-name-error"
    >Name must be 4-64 characters long</span
  >
</form>
